import { connect } from 'react-redux'
import siteActions from 'store/sites/actions'
import fireRollCallActions from 'store/fire-roll-call/actions'
import currentSiteAction from 'store/current-site/actions'
import { setMenuSelectedState } from 'store/menu-selected/actions'
import FireRollCall from './FireRollCall'

const mapStateToProps = state => ({
  currentSite: state.currentSite,
  fireRollCall: state.fireRollCall,
  isSiteSearchSuggestionsVisible: state.sites.searched
})

const mapDispatchToProps = dispatch => ({
  initialiseSites: () => {
    dispatch({ type: siteActions.resetSites })
    dispatch({ type: fireRollCallActions.resetFireRollCall })
    dispatch({ type: currentSiteAction.resetCurrentSite })
  },
  setMenuSelectedState: (state) => {
    dispatch(setMenuSelectedState(state))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(FireRollCall)



// WEBPACK FOOTER //
// ./src/components/FireRollCall/index.jsx